import React from 'react'
import { Container, IconContent, Label, StyledIcon } from './styles'

export const OptionButton = ({isActive, onClick, iconName, labelText}) => {
  return (
    <Container onClick={onClick}>
      <IconContent active={isActive}>
        <StyledIcon
          name={iconName}
        />
      </IconContent>
      <Label active={isActive}>
        {labelText}
      </Label>
    </Container>
  )
}
